import { getActiveAccount } from '@/common/auth';

export default {
  // Loading State

  loading(state) {
    return state.loading;
  },

  isLoading(state, getters) {
    return getters.loading > 0;
  },

  isLoaded(state, getters) {
    return !getters.isLoading;
  },

  // User

  currentUser() {
    return getActiveAccount();
  },

  isAuthenticated(state) {
    return state.isSignedIn;
  },

  isAuthenticatedAsAdmin() {
    // Todo: Find a solution to know if the user itself is an admin
    return true;
  },
};



// WEBPACK FOOTER //
// ./store/getters.js